import React from 'react'
import AbstractResult from '../../../models/AbstractResult'
import Party from '../../../models/Party'
import PartyResult from '../../../models/PartyResult'
import Utilities from '../../../utils/Utilities'

interface IProps {
  className?: string
  party: Party
  areaResult: AbstractResult
  accessor: (result: PartyResult) => number
  formatter?: (input: number) => string
}

export const PartyResultCell = (props: IProps): JSX.Element => {
  const { accessor, areaResult, party } = props
  const formatter = props.formatter || ((num: number): string => `${num}`)
  const isWinner = areaResult.winner().party.key === party.key
  const result = areaResult.partyResultByParty(party)

  return (
    <td
      className={`${props.className} ${Utilities.boldIf(isWinner)}`}
      style={{ color: party.rgbColor }}
    >
      {result ? formatter(accessor(result)) : '—'}
    </td>
  )
}
